import { ApplicationTheme } from './types';

export default function getAppName(theme?: string): string {
  switch (theme) {
    case ApplicationTheme.CORTEX:
      return 'Cortexapp';
    case ApplicationTheme.MIND:
      return 'Mind';
    default:
      return 'Fyzion';
  }
}
